// extracted by mini-css-extract-plugin
export default {"modal":"rR-z","sharingIconsV2":"sR-z","notificationBox":"tR-z","checkMark":"uR-z","textFrame":"vR-z"};